var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 23.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.35 2.6 14.35 5.21 14.99 5.21 15.63 5.21 15.63 2.6 15.63 0 14.99 0 14.35 0 14.35 2.6 14.35 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.36,1.69a2.66,2.66,0,0,0-.53.38s2.71,4.36,2.73,4.39,1-.63,1.07-.68S11.21,5,10.3,3.57L8.93,1.37a3.48,3.48,0,0,0-.57.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,1.39c-.06.08-2.73,4.38-2.73,4.39l.84.53.25.16,1.36-2.19L22.1,2.06a2.19,2.19,0,0,0-.42-.3C21,1.33,21,1.34,21,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.19,7.85a7.74,7.74,0,0,0-3,.83,7.84,7.84,0,0,0-3.06,2.75,8.11,8.11,0,0,0-.92,2c0,.08-.05.14-.06.14l-.2-.11a2.58,2.58,0,0,0-3.19.38,2.54,2.54,0,0,0-.66,1.12,1.88,1.88,0,0,0-.08.71,1.88,1.88,0,0,0,.08.71,2.62,2.62,0,0,0,2.09,1.86,2.71,2.71,0,0,0,1.77-.35l.2-.11s0,.06.06.14a8.23,8.23,0,0,0,1.4,2.64,7.87,7.87,0,0,0,6.6,2.91,7.59,7.59,0,0,0,2.62-.63,7.89,7.89,0,0,0,3.91-3.73,6.84,6.84,0,0,0,.57-1.53,6.7,6.7,0,0,0,.23-2.12A5.9,5.9,0,0,0,19.44,14c0-.06,0-.07.15-.1l2.37-.5L26,12.56l2.84-.6,1-.22.07,0V7.81H16.95v2.62H13V7.81H12.3l-1.11,0Zm.55,2.59v1.3h6.53V9.13H28.68v.78a2.56,2.56,0,0,1,0,.79l-5.46,1.17L17.75,13a1.53,1.53,0,0,0,.08.22,5.87,5.87,0,0,1,.41,2.39,6.36,6.36,0,0,1-.71,3,6.49,6.49,0,0,1-7,3.41,6.45,6.45,0,0,1-5.31-6.41,5.92,5.92,0,0,1,.32-2,6.6,6.6,0,0,1,4.77-4.32,3.58,3.58,0,0,1,1.07-.15h.36v1.3ZM2.89,14.38a1.18,1.18,0,0,1,1,1,1.27,1.27,0,0,1-.93,1.49,2.13,2.13,0,0,1-.37,0,1.22,1.22,0,0,1-1.2-.77,1.88,1.88,0,0,1-.06-.86,1.26,1.26,0,0,1,1.57-.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.eb1d288ad099adbd254305e9b14e5807.svg";
export { ForwardRef as ReactComponent };